import { defineStore } from "pinia";
import type Alert from "@/interfaces/Alerts/Alert";

export const useAlertsStore = defineStore("alerts", {
  state: () => ({
    alert: undefined as Alert | undefined,
  }),
  actions: {
    setAlert(alert: Alert | undefined) {
      this.alert = alert ? { ...alert } : undefined;
    },
    clearAlert() {
      this.alert = undefined;
    },
  },
});
